<template>
  <div class="container single">
    <div class="loadingScreen">
      <icon :size="2.8" :pulse="true" fas="fa-spinner" color="blue" class="icon margin3" />
      <div>...処理中です。</div>
    </div>
  </div>
</template>
<script>
import Cookies from 'mj-cookie'
import {
  COOKIE_AMAZON_PURCHASE_PATH,
  COOKIE_AMAZON_CHECKOUT_SESSION_ID,
  CHECKOUT_SESSION_COOKIE_EXPIRE_TIME,
  COOKIE_AMAZON_PURCHASE_QUANTITY
} from '@/utils/constants/amazonPay'
import { isMJDomain } from '@/utils/url-action'
export default {
  setup() {
    definePageMeta({
      layout: 'simple'
    })
  },
  mounted() {
    if (import.meta.client) {
      this.setUpCheckoutSessionIdCookies()
      this.redirectAmazonPayURL()
    }
  },
  methods: {
    setUpCheckoutSessionIdCookies() {
      const checkoutSessionId = this.$route.query.amazonCheckoutSessionId
      if (checkoutSessionId && checkoutSessionId !== Cookies.get(COOKIE_AMAZON_CHECKOUT_SESSION_ID) && checkoutSessionId !== '') {
        Cookies.set(COOKIE_AMAZON_CHECKOUT_SESSION_ID, checkoutSessionId, { expires: CHECKOUT_SESSION_COOKIE_EXPIRE_TIME })
      }
    },
    redirectAmazonPayURL() {
      let redirectPath
      if (this.$store.$state.my_profile) {
        redirectPath = Cookies.get(COOKIE_AMAZON_PURCHASE_PATH) ? `${Cookies.get(COOKIE_AMAZON_PURCHASE_PATH)}/amazon_purchases/new/` : '/'
      } else {
        redirectPath = Cookies.get(COOKIE_AMAZON_PURCHASE_PATH) ? `${Cookies.get(COOKIE_AMAZON_PURCHASE_PATH)}/amazon_purchases/guest_new/` : '/'
      }
      if (!isMJDomain(redirectPath)) {
        redirectPath = '/'
      }
      window.location.href = Cookies.get(COOKIE_AMAZON_PURCHASE_QUANTITY)
        ? `${redirectPath}?quantity=${Cookies.get(COOKIE_AMAZON_PURCHASE_QUANTITY)}`
        : redirectPath
    }
  }
}
</script>
<style lang="scss" scoped>
.loadingScreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: $white;
  text-align: center;
  padding-top: 10rem;
  z-index: 99;
}
</style>
